"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductToJSON = exports.ProductFromJSONTyped = exports.ProductFromJSON = exports.instanceOfProduct = void 0;
var PriceBreakdown_1 = require("./PriceBreakdown");
var ProductType_1 = require("./ProductType");
/**
 * Check if a given object implements the Product interface.
 */
function instanceOfProduct(value) {
    var isInstance = true;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "productMFEUrl" in value;
    isInstance = isInstance && "productType" in value;
    isInstance = isInstance && "priceBreakdown" in value;
    isInstance = isInstance && "distributionId" in value;
    isInstance = isInstance && "adPlat" in value;
    isInstance = isInstance && "token" in value;
    return isInstance;
}
exports.instanceOfProduct = instanceOfProduct;
function ProductFromJSON(json) {
    return ProductFromJSONTyped(json, false);
}
exports.ProductFromJSON = ProductFromJSON;
function ProductFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'productId': json['productId'],
        'productMFEUrl': json['productMFEUrl'],
        'productType': (0, ProductType_1.ProductTypeFromJSON)(json['productType']),
        'priceBreakdown': (0, PriceBreakdown_1.PriceBreakdownFromJSON)(json['priceBreakdown']),
        'distributionId': json['distributionId'],
        'adPlat': json['adPlat'],
        'token': json['token'],
    };
}
exports.ProductFromJSONTyped = ProductFromJSONTyped;
function ProductToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'productId': value.productId,
        'productMFEUrl': value.productMFEUrl,
        'productType': (0, ProductType_1.ProductTypeToJSON)(value.productType),
        'priceBreakdown': (0, PriceBreakdown_1.PriceBreakdownToJSON)(value.priceBreakdown),
        'distributionId': value.distributionId,
        'adPlat': value.adPlat,
        'token': value.token,
    };
}
exports.ProductToJSON = ProductToJSON;
